import React, { FC, FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import SocialsList from "shared/SocialsList/SocialsList";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface PageContactProps {
	className?: string;
}

const CONTACT_EMAIL = "order@ifhkltd.com";

const PageContact: FC<PageContactProps> = ({ className = "" }) => {
	const { t } = useTranslation();
	const [formValue, setFormValue] = useState({ name: "", email: "", message: "" });

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		const subject = t("contact.email_subject", { name: formValue.name });
		const body = `${t("contact.full_name")}: ${formValue.name}\n${t("contact.email_address")}: ${formValue.email}\n\n${formValue.message}`;
		window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
	};

	return (
		<div
			className={`nc-PageContact overflow-hidden ${className}`}
			data-nc-id="PageContact"
		>
			<div className="mb-24 lg:mb-32">
				<h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
					{t("contact.title")}
				</h2>
				<div className="container max-w-7xl mx-auto">
					<div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
						<div className="max-w-sm space-y-8">
							<div>
								<h3 className="text-sm font-semibold uppercase dark:text-neutral-200">{t("contact.email")}</h3>
								<a className="mt-2 block text-neutral-500 hover:text-primary-6000 dark:text-neutral-400" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
							</div>
							<div>
								<h3 className="text-sm font-semibold uppercase dark:text-neutral-200">{t("contact.phone")}</h3>
								<a className="mt-2 block text-neutral-500 hover:text-primary-6000 dark:text-neutral-400" href="tel:+85235639187">HK: +852 3563 9187</a>
								<a className="mt-2 block text-neutral-500 hover:text-primary-6000 dark:text-neutral-400" href="tel:+8617179955357">China: +86 171 7995 5357</a>
							</div>
							<div>
								<h3 className="text-sm font-semibold uppercase dark:text-neutral-200">{t("contact.socials")}</h3>
								<SocialsList className="mt-2" />
							</div>
						</div>
						<div>
							<form className="grid grid-cols-1 gap-6" onSubmit={onSubmit}>
								<label className="block">
									<span className="text-sm font-medium text-neutral-700 dark:text-neutral-300">{t("contact.full_name")}</span>
									<Input
										name="name"
										value={formValue.name}
										onChange={(event) => setFormValue((current) => ({ ...current, name: event.target.value }))}
										type="text"
										className="mt-1"
										required
									/>
								</label>
								<label className="block">
									<span className="text-sm font-medium text-neutral-700 dark:text-neutral-300">{t("contact.email_address")}</span>
									<Input
										name="email"
										value={formValue.email}
										onChange={(event) => setFormValue((current) => ({ ...current, email: event.target.value }))}
										type="email"
										placeholder="example@example.com"
										className="mt-1"
										required
									/>
								</label>
								<label className="block">
									<span className="text-sm font-medium text-neutral-700 dark:text-neutral-300">{t("contact.message")}</span>
									<Textarea
										className="mt-1"
										name="message"
										rows={6}
										value={formValue.message}
										onChange={(event) => setFormValue((current) => ({ ...current, message: event.target.value }))}
										required
									/>
								</label>
								<div>
									<ButtonPrimary type="submit">{t("contact.send")}</ButtonPrimary>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PageContact;
